module.exports = "https://cdn.dove.it/_next/static/public/assets/trustpilot-stars.b5364f605d1b8c5d17edccd2a95deaef.png";